import React, {
  useEffect,
  useState
} from "react";
import { connect } from "react-redux";
import { 
  Box,
  Container,
  Typography
} from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import PDFViewer from "../../components/pdfviewer/all-pages";
import { handoutsService } from "../../services";
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Description from '@material-ui/icons/Description'
import images from "./../../common/images"
import { borderRadius } from "@mui/system";

interface Props {
  resources: IResource[]
}

interface IResource {
  id?:string,
  name?: string,
  path? : string,
  uploadedByUser?: number
}

interface State {
    resources: IResource[],
}

const useStyles = makeStyles((theme) => ({
  parentContainer :{
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    marginTop: 50
  },
  buttonLink :{
    border:"1px solid blue"
  },
  title :{
    noWrap: "false",
    align:"center",
    width: 250,
    margin: 15
  },
  fullPageContainer: {
    height: "100%",
    maxHeight: "500px",
    overflowY: "auto",
    overflowX: "hidden"
  },

  docContainer: {
    height: 250,
    width: 250,
    margin: 15
  },

  dispContainer :{
    textAlign:"center",
  },
}));

const initContent: IResource[] = [{
  id:"",
  name: "",
  path : "",
  uploadedByUser: 0
}];

const HandoutsPage = (props: Props) => {
  const classes = useStyles();
  const [resources, setResources] = useState([initContent]);
  const [open, setOpen] = useState(999);

  const handleClickOpen = (id) => (e)  => {
    setOpen(id);
  };

  const handleClose= (id) => (e)  => {
    setOpen(999);
  };

  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  const getImgPath = (name : string) =>{
    let path : string | undefined;
    images.forEach((image) => {
      if(image.name === name) {
        path = image!.value;
      }
    })
    return path;
  }

  const handleDownload = (url: string) =>{
    window.open(url);
  }
  
  useEffect(() => {
      handoutsService.getHandouts()
        .then((resp) => {
          const data = resp;
          setResources(data);
        }).catch((err) => {
          // TODO handle errors properly, show alert or something of the like
          console.error(err);
        });

  },[])
  
  return (
    <Container className={classes.parentContainer}>
      
      {resources.map( (resource, index) => ( 
        <Box className={classes.dispContainer} key={index} >
          <Box className={classes.docContainer} onClick={handleClickOpen(index)}>
            <img alt="" style={{height:"250px", cursor: "pointer"}} src={getImgPath(resource.name)}/>
          </Box>
          <Typography variant="h6" className={classes.title}>{resource.name}</Typography>
          <Dialog
              open={index === open ? true : false}
              onClose={handleClose(index)}
              aria-labelledby="scroll-dialog-title"
              maxWidth="xl"
              aria-describedby="scroll-dialog-description"
            >
              <DialogTitle id="scroll-dialog-title">{resource.name}</DialogTitle>
              <DialogContent>
                <DialogContentText
                  id="scroll-dialog-description"
                  tabIndex={-1}
                >
                  <div className={classes.fullPageContainer}>
                    <PDFViewer pdf={resource.path} />
                  </div>
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                {/* <a className="MuiButton-root MuiButton-text MuiButton-textPrimary MuiButton-sizeMedium MuiButton-textSizeMedium MuiButtonBase-root css-1e6y48t-MuiButtonBase-root-MuiButton-root" target="_blank" style={{color:"inherit", textDecoration:"none"}} rel="noopener noreferrer" href={resource.path}>download</a> */}
                <Button target="_blank" rel="noopener noreferrer" href={resource.path}>Download</Button>
                <Button onClick={handleClose(index)}>Close</Button>
              </DialogActions>
            </Dialog>
        </Box>
      ))} 

    </Container>
  ) 
};

const mapStateToProps = (state: State) => {
  const resources  = state.resources;
  return {
    resources
  }
}
const exportedHandouts = connect(mapStateToProps)(HandoutsPage);
export { exportedHandouts as HandoutsPage };